





















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class TermList extends Vue {
  @Prop({ required: true })
  value!: string[];

  dialog = false;
  private t(key: string): string {
    return this.$t("appointments.noteDialog." + key).toString();
  }
}
